import validate from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}